import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import { useVideoByUuid } from "../../../../utils/youtubeApiQueries";
import VideoWatchNavbar from "../../../../components/VideoWatchNavbar";
import Spinner from "../../../../components/spinner";
import NotFound from "../../../../components/not-found/notFound";
import styles from "./VideoWatchPage.module.css";

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export default function VideoWatchPage() {
  const { videoUuid } = useParams();
  const navigate = useNavigate();

  const isValidUuid = (id) => id && UUID_REGEX.test(String(id).trim());

  const { data: video, isLoading, error } = useVideoByUuid(
    isValidUuid(videoUuid) ? videoUuid : null
  );

  if (!isValidUuid(videoUuid) || error) {
    return <NotFound />;
  }

  if (isLoading) {
    return (
      <>
        <VideoWatchNavbar />
        <div className={styles.page}>
          <div className={styles.container}>
            <div className={styles.loadingContainer}>
              <Spinner scale={4} color="#0F1A52" />
              <p className={styles.loadingText}>Loading video…</p>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (error || !video) {
    return (
      <>
        <VideoWatchNavbar />
        <div className={styles.page}>
          <div className={styles.container}>
            <div className={styles.error}>{error || "Video not found"}</div>
          </div>
        </div>
      </>
    );
  }

  const youtubeId = video.youtube_video_id || video.youtubeId || video.youtube_video;
  if (!youtubeId) {
    return (
      <>
        <VideoWatchNavbar />
        <div className={styles.page}>
          <div className={styles.container}>
            <div className={styles.error}>This video is not available to play.</div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <VideoWatchNavbar />
        <div className={styles.container}>
          
          <div className={styles.header}>
            {video.title && <h1 className={styles.title}>{video.title}</h1>}
            {video.description && <p className={styles.description}>{video.description}</p>}
          </div>

          <div className={styles.videoWrapper}>
            <div className={styles.videoContainer}>
              <iframe
                className={styles.iframe}
                src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`}
                title={video.title || "Video"}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>

          <div className={styles.videoInfo}>
            <h2 className={styles.videoTitle}>{video.title}</h2>
            <div className={styles.videoMeta}>
              <div className={styles.metaItem}>
                Category: {video.category_name || 'Uncategorized'}
              </div>
              {video.created_at && (
                <div className={styles.metaItem}>
                  Added: {new Date(video.created_at).toLocaleDateString()}
                </div>
              )}
            </div>
          </div>
        </div>
    </>
  );
}
